import { render, staticRenderFns } from "./NewcastleCity.vue?vue&type=template&id=1e1d033a&scoped=true&"
import script from "./NewcastleCity.vue?vue&type=script&lang=js&"
export * from "./NewcastleCity.vue?vue&type=script&lang=js&"
import style0 from "./NewcastleCity.vue?vue&type=style&index=0&id=1e1d033a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1d033a",
  null
  
)

export default component.exports